import React from "react";
import ProfileSection from "./ProfileSection";
import SecuritySection from "./SecuritySection";
import DeleteAccountSection from "./DeleteAccountSection";

export default function AccountSettings() {
  return (
    <article className="mx-auto mt-0 max-w-3xl px-4 py-8 text-mauve-900">
      <h1 className="mb-2 text-center text-3xl font-semibold text-mauve-900">
        Account settings
      </h1>
      <p className="mb-10 text-center text-sm text-mauve-600">
        Manage your profile, sign-in security, and account data.
      </p>

      <ProfileSection />
      <SecuritySection />
      <DeleteAccountSection />
    </article>
  );
}
